import router from '@this/router';
import { isAlipay } from '@/utils/browser';

const state = {};

const mutations = {};

const actions = {
  // 事件
  gotoIndex() {
    router.push('/index');
  },
  gotoRule() {
    router.push('/rule');
  },
  gotoMy() {
    router.push('/my');
  },
  gotoLink(context, link) {
    if (isAlipay) {
      ap.pushWindow(link);
    } else {
      window.location.href = link;
    }
  },
  gotoArticle(context, { id }) {
    router.push({
      path: '/article',
      query: {
        id,
      },
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
